/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { ENVIRONMENT } from 'config';
import { dashboardActions } from 'modules/dashboard/slice';
import { useSelector, useDispatch } from 'react-redux';
import { IconButton, Tooltip, Popover, ListItemText, ListItem } from '@mui/material';
import { selectNotifications } from 'modules/dashboard/selectors';
import { useRef, useState } from 'react';
import { selectOrganizationId } from 'modules/common/auth/selectors';
import { History } from '@mui/icons-material';
import { Indicator, ScrollList } from '../../style';
import { selectIsRatePlan, selectIsRoomNightsPace, selectIsTravelAgent } from '../../../../selectors';
/**
 * Notification component define here
 * @returns
 */
const NotificationWindow = () => {
  const dispatch = useDispatch();
  //
  const notificationsList = useSelector(selectNotifications);
  const organizationId = useSelector(selectOrganizationId);
  const isRatePlan = useSelector(selectIsRatePlan);
  const isTravelAgentOn = useSelector(selectIsTravelAgent);
  const isRoomNightsPace = useSelector(selectIsRoomNightsPace);
  //
  const [isOpen, setOpen] = useState(false);
  const ref = useRef(null);
  //
  return (
    !isRatePlan && !isTravelAgentOn && !isRoomNightsPace && (
      <>
        <Tooltip title="Notifications">
          <IconButton
            color="inherit"
            onClick={() => setOpen(true)}
            ref={ref}
            size="large"
            sx={{ mr: 2 }}
            disableRipple
          >
            <Indicator
              badgeContent={
                notificationsList?.filter((notificationItem) => !notificationItem.isOpen).length
              }
            >
              <History sx={{ fontSize: 20, color: 'gray' }} />
            </Indicator>
          </IconButton>
        </Tooltip>
        <Popover
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          anchorEl={ref.current}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          onClose={() => setOpen(false)}
          open={isOpen}
        >
          <ScrollList disablePadding>
            {notificationsList?.map((notificationItem) => (
              <ListItem
                divider
                component="a"
                href={`${ENVIRONMENT.AZURE_CDN_URL}/${notificationItem?.payload.fileName}`}
                target="_blank"
                key={1}
                sx={{
                  backgroundColor: notificationItem?.isOpen ? 'white' : '#d3edeb',
                }}
                onClick={() =>
                  dispatch(
                    dashboardActions.updateNotification({
                      organizationId,
                      userId: notificationItem?.userId,
                      notificationId: notificationItem.id,
                      isOpen: true,
                    })
                  )
                }
              >
                <ListItemText
                  primary={notificationItem?.subject}
                  primaryTypographyProps={{
                    variant: 'subtitle2',
                    color: 'textPrimary',
                  }}
                />
              </ListItem>
            ))}
          </ScrollList>
        </Popover>
      </>
    )
  );
};
//
export default NotificationWindow;
